import { ItemCategory } from "./enum/enum";

type InventoryItemInfo = {
  itemId: number,
  categoryId: number,
  typeId: number,
  categoryName: string,
  typeName: string,
  inventoryWorth?: number,
  chance1?: number,
  chance2?: number,
}

export const InventoryItemInfos: InventoryItemInfo[] = [
  {
    itemId: 0,
    categoryId: 0,
    typeId: 0,
    categoryName: "Cash",
    typeName: "50000",
    chance1: 20,
    chance2: 28,
    inventoryWorth: 5,
  },
  {
    itemId: 1,
    categoryId: 0,
    typeId: 1,
    categoryName: "Cash",
    typeName: "150000",
    chance1: 20,
    chance2: 18,
    inventoryWorth: 15,
  },
  {
    itemId: 2,
    categoryId: 0,
    typeId: 2,
    categoryName: "Cash",
    typeName: "250000",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 25,
  },
  {
    itemId: 3,
    categoryId: 0,
    typeId: 3,
    categoryName: "Cash",
    typeName: "350000",
    chance1: 20,
    chance2: 12,
    inventoryWorth: 35,
  },
  {
    itemId: 4,
    categoryId: 0,
    typeId: 4,
    categoryName: "Cash",
    typeName: "500000",
    chance1: 20,
    chance2: 9,
    inventoryWorth: 50,
  },
  {
    itemId: 5,
    categoryId: 0,
    typeId: 5,
    categoryName: "Cash",
    typeName: "1000000",
    chance1: 20,
    chance2: 7,
    inventoryWorth: 100,
  },
  {
    itemId: 6,
    categoryId: 0,
    typeId: 6,
    categoryName: "Cash",
    typeName: "2500000",
    chance1: 20,
    chance2: 5,
    inventoryWorth: 250,
  },
  {
    itemId: 7,
    categoryId: 0,
    typeId: 7,
    categoryName: "Cash",
    typeName: "4000000",
    chance1: 20,
    chance2: 3,
    inventoryWorth: 400,
  },
  {
    itemId: 8,
    categoryId: 0,
    typeId: 8,
    categoryName: "Cash",
    typeName: "5000000",
    chance1: 20,
    chance2: 2,
    inventoryWorth: 500,
  },
  {
    itemId: 9,
    categoryId: 0,
    typeId: 9,
    categoryName: "Cash",
    typeName: "10000000",
    chance1: 20,
    chance2: 1,
    inventoryWorth: 1000,
  },
  {
    itemId: 10,
    categoryId: 1,
    typeId: 0,
    categoryName: "Bullets",
    typeName: "250",
    chance1: 10,
    chance2: 28,
    inventoryWorth: 25,
  },
  {
    itemId: 11,
    categoryId: 1,
    typeId: 1,
    categoryName: "Bullets",
    typeName: "500",
    chance1: 10,
    chance2: 18,
    inventoryWorth: 50,
  },
  {
    itemId: 12,
    categoryId: 1,
    typeId: 2,
    categoryName: "Bullets",
    typeName: "750",
    chance1: 10,
    chance2: 15,
    inventoryWorth: 75,
  },
  {
    itemId: 13,
    categoryId: 1,
    typeId: 3,
    categoryName: "Bullets",
    typeName: "1500",
    chance1: 10,
    chance2: 12,
    inventoryWorth: 150,
  },
  {
    itemId: 14,
    categoryId: 1,
    typeId: 4,
    categoryName: "Bullets",
    typeName: "3500",
    chance1: 10,
    chance2: 9,
    inventoryWorth: 350,
  },
  {
    itemId: 15,
    categoryId: 1,
    typeId: 5,
    categoryName: "Bullets",
    typeName: "5000",
    chance1: 10,
    chance2: 7,
    inventoryWorth: 500,
  },
  {
    itemId: 16,
    categoryId: 1,
    typeId: 6,
    categoryName: "Bullets",
    typeName: "7000",
    chance1: 10,
    chance2: 5,
    inventoryWorth: 700,
  },
  {
    itemId: 17,
    categoryId: 1,
    typeId: 7,
    categoryName: "Bullets",
    typeName: "15000",
    chance1: 10,
    chance2: 3,
    inventoryWorth: 1500,
  },
  {
    itemId: 18,
    categoryId: 1,
    typeId: 8,
    categoryName: "Bullets",
    typeName: "20000",
    chance1: 10,
    chance2: 2,
    inventoryWorth: 2000,
  },
  {
    itemId: 19,
    categoryId: 1,
    typeId: 9,
    categoryName: "Bullets",
    typeName: "30000",
    chance1: 10,
    chance2: 1,
    inventoryWorth: 3000,
  },
  {
    itemId: 20,
    categoryId: 2,
    typeId: 0,
    categoryName: "Health",
    typeName: "50",
    chance1: 15,
    chance2: 28,
    inventoryWorth: 100,
  },
  {
    itemId: 21,
    categoryId: 2,
    typeId: 1,
    categoryName: "Health",
    typeName: "100",
    chance1: 15,
    chance2: 18,
    inventoryWorth: 200,
  },
  {
    itemId: 22,
    categoryId: 2,
    typeId: 2,
    categoryName: "Health",
    typeName: "150",
    chance1: 15,
    chance2: 15,
    inventoryWorth: 300,
  },
  {
    itemId: 23,
    categoryId: 2,
    typeId: 3,
    categoryName: "Health",
    typeName: "200",
    chance1: 15,
    chance2: 12,
    inventoryWorth: 400,
  },
  {
    itemId: 24,
    categoryId: 2,
    typeId: 4,
    categoryName: "Health",
    typeName: "250",
    chance1: 15,
    chance2: 3,
    inventoryWorth: 500,
  },
  {
    itemId: 25,
    categoryId: 2,
    typeId: 5,
    categoryName: "Health",
    typeName: "300",
    chance1: 15,
    chance2: 7,
    inventoryWorth: 600,
  },
  {
    itemId: 26,
    categoryId: 2,
    typeId: 6,
    categoryName: "Health",
    typeName: "350",
    chance1: 15,
    chance2: 5,
    inventoryWorth: 700,
  },
  {
    itemId: 27,
    categoryId: 2,
    typeId: 7,
    categoryName: "Health",
    typeName: "500",
    chance1: 15,
    chance2: 3,
    inventoryWorth: 1000,
  },
  {
    itemId: 28,
    categoryId: 2,
    typeId: 8,
    categoryName: "Health",
    typeName: "750",
    chance1: 15,
    chance2: 2,
    inventoryWorth: 1500,
  },
  {
    itemId: 29,
    categoryId: 2,
    typeId: 9,
    categoryName: "Health",
    typeName: "1000",
    chance1: 15,
    chance2: 1,
    inventoryWorth: 2000,
  },
  {
    itemId: 30,
    categoryId: 3,
    typeId: 0,
    categoryName: "Shop item",
    typeName: "Hand Gun Colt 1911",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 5,
  },
  {
    itemId: 31,
    categoryId: 3,
    typeId: 1,
    categoryName: "Shop item",
    typeName: "Remington model 870",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 15,
  },
  {
    itemId: 32,
    categoryId: 3,
    typeId: 2,
    categoryName: "Shop item",
    typeName: "Thompson 1928",
    chance1: 20,
    chance2: 14,
    inventoryWorth: 24,
  },
  {
    itemId: 33,
    categoryId: 3,
    typeId: 3,
    categoryName: "Shop item",
    typeName: "Molotov cocktail",
    chance1: 20,
    chance2: 12,
    inventoryWorth: 35,
  },
  {
    itemId: 34,
    categoryId: 3,
    typeId: 4,
    categoryName: "Shop item",
    typeName: "Grenade",
    chance1: 20,
    chance2: 11,
    inventoryWorth: 50,
  },
  {
    itemId: 35,
    categoryId: 3,
    typeId: 5,
    categoryName: "Shop item",
    typeName: "Motorcycle",
    chance1: 20,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 36,
    categoryId: 3,
    typeId: 6,
    categoryName: "Shop item",
    typeName: "Bullet proof vest",
    chance1: 20,
    chance2: 8,
    inventoryWorth: 250,
  },
  {
    itemId: 37,
    categoryId: 3,
    typeId: 7,
    categoryName: "Shop item",
    typeName: "Bullet proof suit",
    chance1: 20,
    chance2: 7,
    inventoryWorth: 500,
  },
  {
    itemId: 38,
    categoryId: 3,
    typeId: 8,
    categoryName: "Shop item",
    typeName: "Armored car",
    chance1: 20,
    chance2: 5,
    inventoryWorth: 750,
  },
  {
    itemId: 39,
    categoryId: 3,
    typeId: 9,
    categoryName: "Shop item",
    typeName: "Douglas M-3",
    chance1: 20,
    chance2: 3,
    inventoryWorth: 850,
  },
  {
    itemId: 40,
    categoryId: 4,
    typeId: 0,
    categoryName: "Business objects",
    typeName: "Car crusher",
    chance1: 2,
    chance2: 17,
    inventoryWorth: 1500,
  },
  {
    itemId: 41,
    categoryId: 4,
    typeId: 1,
    categoryName: "Business objects",
    typeName: "Shop owner",
    chance1: 2,
    chance2: 17,
    inventoryWorth: 5000,
  },
  {
    itemId: 42,
    categoryId: 4,
    typeId: 2,
    categoryName: "Business objects",
    typeName: "Bank",
    chance1: 2,
    chance2: 16,
    inventoryWorth: 3000,
  },
  {
    itemId: 43,
    categoryId: 4,
    typeId: 3,
    categoryName: "Business objects",
    typeName: "Hospital",
    chance1: 2,
    chance2: 16,
    inventoryWorth: 5000,
  },
  {
    itemId: 44,
    categoryId: 4,
    typeId: 4,
    categoryName: "Business objects",
    typeName: "Detective Agency",
    chance1: 2,
    chance2: 12,
    inventoryWorth: 2000,
  },
  {
    itemId: 45,
    categoryId: 4,
    typeId: 5,
    categoryName: "Business objects",
    typeName: "Booze warehouse",
    chance1: 2,
    chance2: 8,
    inventoryWorth: 8000,
  },
  {
    itemId: 46,
    categoryId: 4,
    typeId: 6,
    categoryName: "Business objects",
    typeName: "Narcotics warehouse",
    chance1: 2,
    chance2: 6,
    inventoryWorth: 8000,
  },
  {
    itemId: 47,
    categoryId: 4,
    typeId: 7,
    categoryName: "Business objects",
    typeName: "Slotmachine",
    chance1: 2,
    chance2: 3,
    inventoryWorth: 9500,
  },
  {
    itemId: 48,
    categoryId: 4,
    typeId: 8,
    categoryName: "Business objects",
    typeName: "Roulette",
    chance1: 2,
    chance2: 3,
    inventoryWorth: 11000,
  },
  {
    itemId: 49,
    categoryId: 4,
    typeId: 9,
    categoryName: "Business objects",
    typeName: "Bullet factory\r\n",
    chance1: 2,
    chance2: 2,
    inventoryWorth: 15000,
  },
  {
    itemId: 50,
    categoryId: 5,
    typeId: 0,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Johnny",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 51,
    categoryId: 5,
    typeId: 1,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Jim",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 150,
  },
  {
    itemId: 52,
    categoryId: 5,
    typeId: 2,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Sam",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 200,
  },
  {
    itemId: 53,
    categoryId: 5,
    typeId: 3,
    categoryName: "Bodyguards",
    typeName: "Lvl 5 - Johnny",
    chance1: 12,
    chance2: 20,
    inventoryWorth: 300,
  },
  {
    itemId: 54,
    categoryId: 5,
    typeId: 4,
    categoryName: "Bodyguards",
    typeName: "Lvl 6 - Jim",
    chance1: 12,
    chance2: 20,
    inventoryWorth: 400,
  },
  {
    itemId: 55,
    categoryId: 5,
    typeId: 5,
    categoryName: "Bodyguards",
    typeName: "Lvl 6 - Sam",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 600,
  },
  {
    itemId: 56,
    categoryId: 5,
    typeId: 6,
    categoryName: "Bodyguards",
    typeName: "Lvl 7 - Frank",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 1000,
  },
  {
    itemId: 57,
    categoryId: 5,
    typeId: 7,
    categoryName: "Bodyguards",
    typeName: "Lvl 8 - Johnny",
    chance1: 12,
    chance2: 5,
    inventoryWorth: 1500,
  },
  {
    itemId: 58,
    categoryId: 5,
    typeId: 8,
    categoryName: "Bodyguards",
    typeName: "Lvl 10 - Sam",
    chance1: 12,
    chance2: 4,
    inventoryWorth: 2000,
  },
  {
    itemId: 59,
    categoryId: 5,
    typeId: 9,
    categoryName: "Bodyguards",
    typeName: "Lvl 10 - Frank",
    chance1: 12,
    chance2: 1,
    inventoryWorth: 2500,
  },
  {
    itemId: 60,
    categoryId: 6,
    typeId: 0,
    categoryName: "Helper credits",
    typeName: "100",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 10,
  },
  {
    itemId: 61,
    categoryId: 6,
    typeId: 1,
    categoryName: "Helper credits",
    typeName: "250",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 25,
  },
  {
    itemId: 62,
    categoryId: 6,
    typeId: 2,
    categoryName: "Helper credits",
    typeName: "500",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 50,
  },
  {
    itemId: 63,
    categoryId: 6,
    typeId: 3,
    categoryName: "Helper credits",
    typeName: "1000",
    chance1: 4,
    chance2: 20,
    inventoryWorth: 100,
  },
  {
    itemId: 64,
    categoryId: 6,
    typeId: 4,
    categoryName: "Helper credits",
    typeName: "1500",
    chance1: 4,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 65,
    categoryId: 6,
    typeId: 5,
    categoryName: "Helper credits",
    typeName: "2000",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 200,
  },
  {
    itemId: 66,
    categoryId: 6,
    typeId: 6,
    categoryName: "Helper credits",
    typeName: "2500",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 250,
  },
  {
    itemId: 67,
    categoryId: 6,
    typeId: 7,
    categoryName: "Helper credits",
    typeName: "3000",
    chance1: 4,
    chance2: 5,
    inventoryWorth: 300,
  },
  {
    itemId: 68,
    categoryId: 6,
    typeId: 8,
    categoryName: "Helper credits",
    typeName: "3500",
    chance1: 4,
    chance2: 4,
    inventoryWorth: 350,
  },
  {
    itemId: 69,
    categoryId: 6,
    typeId: 9,
    categoryName: "Helper credits",
    typeName: "5000",
    chance1: 4,
    chance2: 1,
    inventoryWorth: 500,
  },
  {
    itemId: 70,
    categoryId: 7,
    typeId: 0,
    categoryName: "Car",
    typeName: "5000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 20,
  },
  {
    itemId: 71,
    categoryId: 7,
    typeId: 1,
    categoryName: "Car",
    typeName: "15000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 50,
  },
  {
    itemId: 72,
    categoryId: 7,
    typeId: 2,
    categoryName: "Car",
    typeName: "35000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 73,
    categoryId: 7,
    typeId: 3,
    categoryName: "Car",
    typeName: "75000",
    chance1: 17,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 74,
    categoryId: 7,
    typeId: 4,
    categoryName: "Car",
    typeName: "100000",
    chance1: 17,
    chance2: 20,
    inventoryWorth: 200,
  },
  {
    itemId: 75,
    categoryId: 7,
    typeId: 5,
    categoryName: "Car",
    typeName: "150000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 250,
  },
  {
    itemId: 76,
    categoryId: 7,
    typeId: 6,
    categoryName: "Car",
    typeName: "250000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 450,
  },
  {
    itemId: 77,
    categoryId: 7,
    typeId: 7,
    categoryName: "Car",
    typeName: "350000",
    chance1: 17,
    chance2: 5,
    inventoryWorth: 500,
  },
  {
    itemId: 78,
    categoryId: 7,
    typeId: 8,
    categoryName: "Car",
    typeName: "450000",
    chance1: 17,
    chance2: 4,
    inventoryWorth: 550,
  },
  {
    itemId: 79,
    categoryId: 7,
    typeId: 9,
    categoryName: "Car",
    typeName: "500000",
    chance1: 17,
    chance2: 1,
    inventoryWorth: 600,
  },
  {
    itemId: 80,
    categoryId: 8,
    typeId: 0,
    categoryName: "Wrapped Item",
    typeName: "Wrapped Key",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 81,
    categoryId: 8,
    typeId: 1,
    categoryName: "Wrapped Item",
    typeName: "Wrapped OG NFT",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 1500,
  },
  {
    itemId: 90,
    categoryId: 9,
    typeId: 0,
    categoryName: "Key Item",
    typeName: "1",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 91,
    categoryId: 9,
    typeId: 1,
    categoryName: "Key Item",
    typeName: "3",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 450,
  },
  {
    itemId: 92,
    categoryId: 9,
    typeId: 2,
    categoryName: "Key Item",
    typeName: "5",
    chance1: 5,
    chance2: 14,
    inventoryWorth: 750,
  },
  {
    itemId: 93,
    categoryId: 9,
    typeId: 3,
    categoryName: "Key Item",
    typeName: "7",
    chance1: 5,
    chance2: 12,
    inventoryWorth: 1050,
  },
  {
    itemId: 94,
    categoryId: 9,
    typeId: 4,
    categoryName: "Key Item",
    typeName: "10",
    chance1: 5,
    chance2: 11,
    inventoryWorth: 1500,
  },
  {
    itemId: 95,
    categoryId: 9,
    typeId: 5,
    categoryName: "Key Item",
    typeName: "15",
    chance1: 5,
    chance2: 10,
    inventoryWorth: 2250,
  },
  {
    itemId: 96,
    categoryId: 9,
    typeId: 6,
    categoryName: "Key Item",
    typeName: "25",
    chance1: 5,
    chance2: 8,
    inventoryWorth: 3750,
  },
  {
    itemId: 97,
    categoryId: 9,
    typeId: 7,
    categoryName: "Key Item",
    typeName: "50",
    chance1: 5,
    chance2: 3,
    inventoryWorth: 7500,
  },
  {
    itemId: 98,
    categoryId: 9,
    typeId: 8,
    categoryName: "Key Item",
    typeName: "75",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 11250,
  },
  {
    itemId: 99,
    categoryId: 9,
    typeId: 9,
    categoryName: "Key Item",
    typeName: "100",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 15000,
  },
  {
    itemId: 100,
    categoryId: 10,
    typeId: 0,
    categoryName: "Wrapped Mafia",
    typeName: "10000",
    chance1: 5,
    chance2: 22,
    inventoryWorth: 4.5,
  },
  {
    itemId: 101,
    categoryId: 10,
    typeId: 1,
    categoryName: "Wrapped Mafia",
    typeName: "15000",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 6.75,
  },
  {
    itemId: 102,
    categoryId: 10,
    typeId: 2,
    categoryName: "Wrapped Mafia",
    typeName: "20000",
    chance1: 5,
    chance2: 17,
    inventoryWorth: 9,
  },
  {
    itemId: 103,
    categoryId: 10,
    typeId: 3,
    categoryName: "Wrapped Mafia",
    typeName: "30000",
    chance1: 5,
    chance2: 14,
    inventoryWorth: 13.5,
  },
  {
    itemId: 104,
    categoryId: 10,
    typeId: 4,
    categoryName: "Wrapped Mafia",
    typeName: "50000",
    chance1: 5,
    chance2: 11,
    inventoryWorth: 22.5,
  },
  {
    itemId: 105,
    categoryId: 10,
    typeId: 5,
    categoryName: "Wrapped Mafia",
    typeName: "100000",
    chance1: 5,
    chance2: 10,
    inventoryWorth: 45,
  },
  {
    itemId: 106,
    categoryId: 10,
    typeId: 6,
    categoryName: "Wrapped Mafia",
    typeName: "250000",
    chance1: 5,
    chance2: 3,
    inventoryWorth: 112.5,
  },
  {
    itemId: 107,
    categoryId: 10,
    typeId: 7,
    categoryName: "Wrapped Mafia",
    typeName: "500000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 225,
  },
  {
    itemId: 108,
    categoryId: 10,
    typeId: 8,
    categoryName: "Wrapped Mafia",
    typeName: "1000000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 450,
  },
  {
    itemId: 109,
    categoryId: 10,
    typeId: 9,
    categoryName: "Wrapped Mafia",
    typeName: "5000000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 2250,
  },
  {
    itemId: 110,
    categoryId: 11,
    typeId: 0,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 111,
    categoryId: 11,
    typeId: 1,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 112,
    categoryId: 11,
    typeId: 2,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 113,
    categoryId: 11,
    typeId: 3,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 114,
    categoryId: 11,
    typeId: 4,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 115,
    categoryId: 11,
    typeId: 5,
    categoryName: "Wrapped OGNFT",
    typeName: "3",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 2250,
  },
  {
    itemId: 116,
    categoryId: 11,
    typeId: 6,
    categoryName: "Wrapped OGNFT",
    typeName: "3",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 2250,
  },
  {
    itemId: 117,
    categoryId: 11,
    typeId: 7,
    categoryName: "Wrapped OGNFT",
    typeName: "7",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 5250,
  },
  {
    itemId: 118,
    categoryId: 11,
    typeId: 8,
    categoryName: "Wrapped OGNFT",
    typeName: "10",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 7500,
  },
  {
    itemId: 119,
    categoryId: 11,
    typeId: 9,
    categoryName: "Wrapped OGNFT",
    typeName: "10",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 7500,
  },
  {
    itemId: 120,
    categoryId: 12,
    typeId: 0,
    categoryName: "Notification Credits",
    typeName: "1",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 10,
  },
  {
    itemId: 121,
    categoryId: 12,
    typeId: 1,
    categoryName: "Notification Credits",
    typeName: "2",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 25,
  },
  {
    itemId: 122,
    categoryId: 12,
    typeId: 2,
    categoryName: "Notification Credits",
    typeName: "3",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 123,
    categoryId: 12,
    typeId: 3,
    categoryName: "Notification Credits",
    typeName: "5",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 124,
    categoryId: 12,
    typeId: 4,
    categoryName: "Notification Credits",
    typeName: "10",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 125,
    categoryId: 12,
    typeId: 5,
    categoryName: "Notification Credits",
    typeName: "15",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 126,
    categoryId: 12,
    typeId: 6,
    categoryName: "Notification Credits",
    typeName: "25",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 127,
    categoryId: 12,
    typeId: 7,
    categoryName: "Notification Credits",
    typeName: "50",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 128,
    categoryId: 12,
    typeId: 8,
    categoryName: "Notification Credits",
    typeName: "75",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 350,
  },
  {
    itemId: 129,
    categoryId: 12,
    typeId: 9,
    categoryName: "Notification Credits",
    typeName: "100",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 500,
  },
  {
    itemId: 130,
    categoryId: 13,
    typeId: 0,
    categoryName: "Slot",
    typeName: "",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 140,
    categoryId: 14,
    typeId: 0,
    categoryName: "Business objects",
    typeName: "Jackpot",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 11000,
  },
  {
    itemId: 141,
    categoryId: 14,
    typeId: 1,
    categoryName: "Business objects",
    typeName: "Lottery Hall",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 11000,
  },
  {
    itemId: 150,
    categoryId: 15,
    typeId: 0,
    categoryName: "New Car",
    typeName: "Rolls-Royce 20/25 HP Standard Sedan - $125,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 225,
  },
  {
    itemId: 151,
    categoryId: 15,
    typeId: 1,
    categoryName: "New Car",
    typeName: "Rolls-Royce 20/25 HP Sports Saloon  - $175,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 152,
    categoryId: 15,
    typeId: 2,
    categoryName: "New Car",
    typeName: "Rolls-Royce Phantom II  - $250,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 450,
  },
  {
    itemId: 153,
    categoryId: 15,
    typeId: 3,
    categoryName: "New Car",
    typeName: "Rolls-Royce Phantom II Continental Limousine  - $500,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 600,
  },
  {
    itemId: 154,
    categoryId: 15,
    typeId: 4,
    categoryName: "New Car",
    typeName: "Bentley 4.5 Litre Standard Tourer  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 155,
    categoryId: 15,
    typeId: 5,
    categoryName: "New Car",
    typeName: "Bentley 4.5 Litre Sports Saloon  - $150,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 156,
    categoryId: 15,
    typeId: 6,
    categoryName: "New Car",
    typeName: "Bentley Speed Six Saloon  - $200,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 157,
    categoryId: 15,
    typeId: 7,
    categoryName: "New Car",
    typeName: "Bentley 8 Litre Limousine by H.J. Mulliner  - $450,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 550,
  },
  {
    itemId: 158,
    categoryId: 15,
    typeId: 8,
    categoryName: "New Car",
    typeName: "Packard Standard Eight Model 726  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 159,
    categoryId: 15,
    typeId: 9,
    categoryName: "New Car",
    typeName: "Packard Standard Eight Model 733  - $125,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 225,
  },
  {
    itemId: 160,
    categoryId: 15,
    typeId: 10,
    categoryName: "New Car",
    typeName: "Packard Deluxe Eight Model 740  - $175,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 161,
    categoryId: 15,
    typeId: 11,
    categoryName: "New Car",
    typeName: "Packard Custom Eight Model 745 Convertible Sedan  - $350,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 500,
  },
  {
    itemId: 162,
    categoryId: 15,
    typeId: 12,
    categoryName: "New Car",
    typeName: "Cadillac Series 353 Standard Sedan  - $70,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 140,
  },
  {
    itemId: 163,
    categoryId: 15,
    typeId: 13,
    categoryName: "New Car",
    typeName: "Cadillac Series 353 Town Sedan  - $120,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 220,
  },
  {
    itemId: 164,
    categoryId: 15,
    typeId: 14,
    categoryName: "New Car",
    typeName: "Cadillac V-16 Imperial Sedan  - $180,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 275,
  },
  {
    itemId: 165,
    categoryId: 15,
    typeId: 15,
    categoryName: "New Car",
    typeName: "Cadillac V-16 Roadster  - $275,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 460,
  },
  {
    itemId: 166,
    categoryId: 15,
    typeId: 16,
    categoryName: "New Car",
    typeName: "Lincoln Model L  - $60,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 140,
  },
  {
    itemId: 167,
    categoryId: 15,
    typeId: 17,
    categoryName: "New Car",
    typeName: "Lincoln Model K sedan  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 168,
    categoryId: 15,
    typeId: 18,
    categoryName: "New Car",
    typeName: "Lincoln Model L Town Car  - $155,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 255,
  },
  {
    itemId: 169,
    categoryId: 15,
    typeId: 19,
    categoryName: "New Car",
    typeName: "Lincoln Model L Limousine  - $250,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 450,
  },
  {
    itemId: 170,
    categoryId: 15,
    typeId: 20,
    categoryName: "New Car",
    typeName: "Chrysler Model 66 sedan  - $40,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 115,
  },
  {
    itemId: 171,
    categoryId: 15,
    typeId: 21,
    categoryName: "New Car",
    typeName: "Chrysler Series 70 sedan  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 172,
    categoryId: 15,
    typeId: 22,
    categoryName: "New Car",
    typeName: "Chrysler Imperial Model 80 Roadster  - $90,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 190,
  },
  {
    itemId: 173,
    categoryId: 15,
    typeId: 23,
    categoryName: "New Car",
    typeName: "Chrysler Imperial Custom Series 8 Limousine  - $150,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 174,
    categoryId: 15,
    typeId: 24,
    categoryName: "New Car",
    typeName: "Buick Series 40  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 175,
    categoryId: 15,
    typeId: 25,
    categoryName: "New Car",
    typeName: "Buick Series 50 sedan  - $35,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 176,
    categoryId: 15,
    typeId: 26,
    categoryName: "New Car",
    typeName: "Buick Series 60 sedan  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 177,
    categoryId: 15,
    typeId: 27,
    categoryName: "New Car",
    typeName: "Buick Series 90 Limited  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 178,
    categoryId: 15,
    typeId: 28,
    categoryName: "New Car",
    typeName: "DeSoto Model K  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 179,
    categoryId: 15,
    typeId: 29,
    categoryName: "New Car",
    typeName: "DeSoto CF Eight sedan  - $25,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 80,
  },
  {
    itemId: 180,
    categoryId: 15,
    typeId: 30,
    categoryName: "New Car",
    typeName: "DeSoto Deluxe Eight sedan  - $40,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 115,
  },
  {
    itemId: 181,
    categoryId: 15,
    typeId: 31,
    categoryName: "New Car",
    typeName: "DeSoto Custom Imperial Limousine  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 182,
    categoryId: 15,
    typeId: 32,
    categoryName: "New Car",
    typeName: "Dodge DC Series sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 183,
    categoryId: 15,
    typeId: 33,
    categoryName: "New Car",
    typeName: "Dodge Eight Series DH sedan  - $25,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 80,
  },
  {
    itemId: 184,
    categoryId: 15,
    typeId: 34,
    categoryName: "New Car",
    typeName: "Dodge Senior Six sedan  - $35,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 185,
    categoryId: 15,
    typeId: 35,
    categoryName: "New Car",
    typeName: "Dodge Deluxe Eight Limousine  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 186,
    categoryId: 15,
    typeId: 36,
    categoryName: "New Car",
    typeName: "Hudson Greater Eight  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 187,
    categoryId: 15,
    typeId: 37,
    categoryName: "New Car",
    typeName: "Hudson Essex Super Six  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 188,
    categoryId: 15,
    typeId: 38,
    categoryName: "New Car",
    typeName: "Hudson Custom Eight  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 189,
    categoryId: 15,
    typeId: 39,
    categoryName: "New Car",
    typeName: "Hudson Greater Eight Custom Limousine  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 190,
    categoryId: 15,
    typeId: 40,
    categoryName: "New Car",
    typeName: "Nash 400 Series sedan  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 191,
    categoryId: 15,
    typeId: 41,
    categoryName: "New Car",
    typeName: "Nash Standard Six sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 192,
    categoryId: 15,
    typeId: 42,
    categoryName: "New Car",
    typeName: "Nash Advanced Eight sedan  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 193,
    categoryId: 15,
    typeId: 43,
    categoryName: "New Car",
    typeName: "Nash Ambassador Eight Limousine  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 194,
    categoryId: 15,
    typeId: 44,
    categoryName: "New Car",
    typeName: "Studebaker Six Standard Sedan  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 195,
    categoryId: 15,
    typeId: 45,
    categoryName: "New Car",
    typeName: "Studebaker Commander Sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 196,
    categoryId: 15,
    typeId: 46,
    categoryName: "New Car",
    typeName: "Studebaker President Eight Sedan  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 197,
    categoryId: 15,
    typeId: 47,
    categoryName: "New Car",
    typeName: "Studebaker President Convertible Coupe  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 198,
    categoryId: 15,
    typeId: 48,
    categoryName: "New Car",
    typeName: "Ford Model A  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 199,
    categoryId: 15,
    typeId: 49,
    categoryName: "New Car",
    typeName: "Ford Model A Deluxe Roadster  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 200,
    categoryId: 15,
    typeId: 50,
    categoryName: "New Car",
    typeName: "Ford Model A Town Car  - $21,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 75,
  },
  {
    itemId: 201,
    categoryId: 15,
    typeId: 51,
    categoryName: "New Car",
    typeName: "Ford Model A Tudor Limousine  - $42,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 120,
  },
  {
    itemId: 202,
    categoryId: 15,
    typeId: 52,
    categoryName: "New Car",
    typeName: "Chevrolet Universal Series AD Coach  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 203,
    categoryId: 15,
    typeId: 53,
    categoryName: "New Car",
    typeName: "Chevrolet Independence Series AE sedan  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 204,
    categoryId: 15,
    typeId: 54,
    categoryName: "New Car",
    typeName: "Chevrolet Series AD Universal Phaeton  - $21,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 75,
  },
  {
    itemId: 205,
    categoryId: 15,
    typeId: 55,
    categoryName: "New Car",
    typeName: "Chevrolet Series AD Universal Landau  - $42,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 120,
  },
  {
    itemId: 206,
    categoryId: 15,
    typeId: 56,
    categoryName: "New Car",
    typeName: "Austin 7  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 207,
    categoryId: 15,
    typeId: 57,
    categoryName: "New Car",
    typeName: "Austin 12/4  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 208,
    categoryId: 15,
    typeId: 58,
    categoryName: "New Car",
    typeName: "Austin 16  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 209,
    categoryId: 15,
    typeId: 59,
    categoryName: "New Car",
    typeName: "Austin 20/6 Mayfair Limousine  - $37,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 105,
  },
  {
    itemId: 210,
    categoryId: 15,
    typeId: 60,
    categoryName: "New Car",
    typeName: "Plymouth Model U  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 211,
    categoryId: 15,
    typeId: 61,
    categoryName: "New Car",
    typeName: "Plymouth 30U sedan  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 212,
    categoryId: 15,
    typeId: 62,
    categoryName: "New Car",
    typeName: "Plymouth PA Deluxe sedan  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 213,
    categoryId: 15,
    typeId: 63,
    categoryName: "New Car",
    typeName: "Plymouth PA Deluxe Limousine  - $37,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 105,
  },
  {
    itemId: 214,
    categoryId: 16,
    typeId: 0,
    categoryName: "FBI Assets",
    typeName: "FBI Training pass",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 1000,
  },
  {
    itemId: 215,
    categoryId: 16,
    typeId: 1,
    categoryName: "FBI Assets",
    typeName: "Detective badge",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 2000,
  },
  {
    itemId: 216,
    categoryId: 16,
    typeId: 2,
    categoryName: "FBI Assets",
    typeName: "Special Agent badge",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 3000,
  },
  {
    itemId: 217,
    categoryId: 16,
    typeId: 3,
    categoryName: "FBI Assets",
    typeName: "Field office business",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 15000,
  },
  {
    itemId: 218,
    categoryId: 17,
    typeId: 0,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 219,
    categoryId: 17,
    typeId: 1,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 220,
    categoryId: 17,
    typeId: 2,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 221,
    categoryId: 17,
    typeId: 3,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 222,
    categoryId: 17,
    typeId: 4,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 223,
    categoryId: 17,
    typeId: 5,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 224,
    categoryId: 17,
    typeId: 6,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 225,
    categoryId: 17,
    typeId: 7,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 226,
    categoryId: 17,
    typeId: 8,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 227,
    categoryId: 17,
    typeId: 9,
    categoryName: "Perk Box",
    typeName: "1",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 228,
    categoryId: 18,
    typeId: 0,
    categoryName: "Success Crime",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 229,
    categoryId: 18,
    typeId: 1,
    categoryName: "Success Crime",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 230,
    categoryId: 18,
    typeId: 2,
    categoryName: "Success Crime",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 231,
    categoryId: 18,
    typeId: 3,
    categoryName: "Success Crime",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 232,
    categoryId: 18,
    typeId: 4,
    categoryName: "Success Crime",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 233,
    categoryId: 18,
    typeId: 5,
    categoryName: "Success Crime",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 234,
    categoryId: 18,
    typeId: 6,
    categoryName: "Success Crime",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 235,
    categoryId: 18,
    typeId: 7,
    categoryName: "Success Crime",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 236,
    categoryId: 18,
    typeId: 8,
    categoryName: "Success Crime",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 237,
    categoryId: 18,
    typeId: 9,
    categoryName: "Success Crime",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 238,
    categoryId: 18,
    typeId: 10,
    categoryName: "Success Crime",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 239,
    categoryId: 18,
    typeId: 11,
    categoryName: "Success Crime",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 240,
    categoryId: 18,
    typeId: 12,
    categoryName: "Success Crime",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 241,
    categoryId: 18,
    typeId: 13,
    categoryName: "Success Crime",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 242,
    categoryId: 18,
    typeId: 14,
    categoryName: "Success Crime",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 243,
    categoryId: 18,
    typeId: 15,
    categoryName: "Success Crime",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 244,
    categoryId: 18,
    typeId: 16,
    categoryName: "Success Crime",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 245,
    categoryId: 18,
    typeId: 17,
    categoryName: "Success Crime",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 246,
    categoryId: 19,
    typeId: 0,
    categoryName: "Success Nick a Car",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 247,
    categoryId: 19,
    typeId: 1,
    categoryName: "Success Nick a Car",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 248,
    categoryId: 19,
    typeId: 2,
    categoryName: "Success Nick a Car",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 249,
    categoryId: 19,
    typeId: 3,
    categoryName: "Success Nick a Car",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 250,
    categoryId: 19,
    typeId: 4,
    categoryName: "Success Nick a Car",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 251,
    categoryId: 19,
    typeId: 5,
    categoryName: "Success Nick a Car",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 252,
    categoryId: 19,
    typeId: 6,
    categoryName: "Success Nick a Car",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 253,
    categoryId: 19,
    typeId: 7,
    categoryName: "Success Nick a Car",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 254,
    categoryId: 19,
    typeId: 8,
    categoryName: "Success Nick a Car",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 255,
    categoryId: 19,
    typeId: 9,
    categoryName: "Success Nick a Car",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 256,
    categoryId: 19,
    typeId: 10,
    categoryName: "Success Nick a Car",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 257,
    categoryId: 19,
    typeId: 11,
    categoryName: "Success Nick a Car",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 258,
    categoryId: 19,
    typeId: 12,
    categoryName: "Success Nick a Car",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 259,
    categoryId: 19,
    typeId: 13,
    categoryName: "Success Nick a Car",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 260,
    categoryId: 19,
    typeId: 14,
    categoryName: "Success Nick a Car",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 261,
    categoryId: 19,
    typeId: 15,
    categoryName: "Success Nick a Car",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 262,
    categoryId: 19,
    typeId: 16,
    categoryName: "Success Nick a Car",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 263,
    categoryId: 19,
    typeId: 17,
    categoryName: "Success Nick a Car",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 264,
    categoryId: 20,
    typeId: 0,
    categoryName: "Success Booze",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 265,
    categoryId: 20,
    typeId: 1,
    categoryName: "Success Booze",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 266,
    categoryId: 20,
    typeId: 2,
    categoryName: "Success Booze",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 267,
    categoryId: 20,
    typeId: 3,
    categoryName: "Success Booze",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 268,
    categoryId: 20,
    typeId: 4,
    categoryName: "Success Booze",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 269,
    categoryId: 20,
    typeId: 5,
    categoryName: "Success Booze",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 270,
    categoryId: 20,
    typeId: 6,
    categoryName: "Success Booze",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 271,
    categoryId: 20,
    typeId: 7,
    categoryName: "Success Booze",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 272,
    categoryId: 20,
    typeId: 8,
    categoryName: "Success Booze",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 273,
    categoryId: 20,
    typeId: 9,
    categoryName: "Success Booze",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 274,
    categoryId: 20,
    typeId: 10,
    categoryName: "Success Booze",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 275,
    categoryId: 20,
    typeId: 11,
    categoryName: "Success Booze",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 276,
    categoryId: 20,
    typeId: 12,
    categoryName: "Success Booze",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 277,
    categoryId: 20,
    typeId: 13,
    categoryName: "Success Booze",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 278,
    categoryId: 20,
    typeId: 14,
    categoryName: "Success Booze",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 279,
    categoryId: 20,
    typeId: 15,
    categoryName: "Success Booze",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 280,
    categoryId: 20,
    typeId: 16,
    categoryName: "Success Booze",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 281,
    categoryId: 20,
    typeId: 17,
    categoryName: "Success Booze",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 282,
    categoryId: 21,
    typeId: 0,
    categoryName: "Success Narcotics",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 283,
    categoryId: 21,
    typeId: 1,
    categoryName: "Success Narcotics",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 284,
    categoryId: 21,
    typeId: 2,
    categoryName: "Success Narcotics",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 285,
    categoryId: 21,
    typeId: 3,
    categoryName: "Success Narcotics",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 286,
    categoryId: 21,
    typeId: 4,
    categoryName: "Success Narcotics",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 287,
    categoryId: 21,
    typeId: 5,
    categoryName: "Success Narcotics",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 288,
    categoryId: 21,
    typeId: 6,
    categoryName: "Success Narcotics",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 289,
    categoryId: 21,
    typeId: 7,
    categoryName: "Success Narcotics",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 290,
    categoryId: 21,
    typeId: 8,
    categoryName: "Success Narcotics",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 291,
    categoryId: 21,
    typeId: 9,
    categoryName: "Success Narcotics",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 292,
    categoryId: 21,
    typeId: 10,
    categoryName: "Success Narcotics",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 293,
    categoryId: 21,
    typeId: 11,
    categoryName: "Success Narcotics",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 294,
    categoryId: 21,
    typeId: 12,
    categoryName: "Success Narcotics",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 295,
    categoryId: 21,
    typeId: 13,
    categoryName: "Success Narcotics",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 296,
    categoryId: 21,
    typeId: 14,
    categoryName: "Success Narcotics",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 297,
    categoryId: 21,
    typeId: 15,
    categoryName: "Success Narcotics",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 298,
    categoryId: 21,
    typeId: 16,
    categoryName: "Success Narcotics",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 299,
    categoryId: 21,
    typeId: 17,
    categoryName: "Success Narcotics",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 300,
    categoryId: 22,
    typeId: 0,
    categoryName: "Success killskill",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 301,
    categoryId: 22,
    typeId: 1,
    categoryName: "Success killskill",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 302,
    categoryId: 22,
    typeId: 2,
    categoryName: "Success killskill",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 303,
    categoryId: 22,
    typeId: 3,
    categoryName: "Success killskill",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 304,
    categoryId: 22,
    typeId: 4,
    categoryName: "Success killskill",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 305,
    categoryId: 22,
    typeId: 5,
    categoryName: "Success killskill",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 306,
    categoryId: 22,
    typeId: 6,
    categoryName: "Success killskill",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 307,
    categoryId: 22,
    typeId: 7,
    categoryName: "Success killskill",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 308,
    categoryId: 22,
    typeId: 8,
    categoryName: "Success killskill",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 309,
    categoryId: 22,
    typeId: 9,
    categoryName: "Success killskill",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 310,
    categoryId: 22,
    typeId: 10,
    categoryName: "Success killskill",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 311,
    categoryId: 22,
    typeId: 11,
    categoryName: "Success killskill",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 312,
    categoryId: 22,
    typeId: 12,
    categoryName: "Success killskill",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 313,
    categoryId: 22,
    typeId: 13,
    categoryName: "Success killskill",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 314,
    categoryId: 22,
    typeId: 14,
    categoryName: "Success killskill",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 315,
    categoryId: 22,
    typeId: 15,
    categoryName: "Success killskill",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 316,
    categoryId: 22,
    typeId: 16,
    categoryName: "Success killskill",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 317,
    categoryId: 22,
    typeId: 17,
    categoryName: "Success killskill",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 318,
    categoryId: 23,
    typeId: 0,
    categoryName: "Success Bustout",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 319,
    categoryId: 23,
    typeId: 1,
    categoryName: "Success Bustout",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 320,
    categoryId: 23,
    typeId: 2,
    categoryName: "Success Bustout",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 321,
    categoryId: 23,
    typeId: 3,
    categoryName: "Success Bustout",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 322,
    categoryId: 23,
    typeId: 4,
    categoryName: "Success Bustout",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 323,
    categoryId: 23,
    typeId: 5,
    categoryName: "Success Bustout",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 324,
    categoryId: 23,
    typeId: 6,
    categoryName: "Success Bustout",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 325,
    categoryId: 23,
    typeId: 7,
    categoryName: "Success Bustout",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 326,
    categoryId: 23,
    typeId: 8,
    categoryName: "Success Bustout",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 327,
    categoryId: 23,
    typeId: 9,
    categoryName: "Success Bustout",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 328,
    categoryId: 23,
    typeId: 10,
    categoryName: "Success Bustout",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 329,
    categoryId: 23,
    typeId: 11,
    categoryName: "Success Bustout",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 330,
    categoryId: 23,
    typeId: 12,
    categoryName: "Success Bustout",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 331,
    categoryId: 23,
    typeId: 13,
    categoryName: "Success Bustout",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 332,
    categoryId: 23,
    typeId: 14,
    categoryName: "Success Bustout",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 333,
    categoryId: 23,
    typeId: 15,
    categoryName: "Success Bustout",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 334,
    categoryId: 23,
    typeId: 16,
    categoryName: "Success Bustout",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 335,
    categoryId: 23,
    typeId: 17,
    categoryName: "Success Bustout",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 336,
    categoryId: 24,
    typeId: 0,
    categoryName: "Cooldown Crime",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 337,
    categoryId: 24,
    typeId: 1,
    categoryName: "Cooldown Crime",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 338,
    categoryId: 24,
    typeId: 2,
    categoryName: "Cooldown Crime",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 339,
    categoryId: 24,
    typeId: 3,
    categoryName: "Cooldown Crime",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 340,
    categoryId: 24,
    typeId: 4,
    categoryName: "Cooldown Crime",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 341,
    categoryId: 24,
    typeId: 5,
    categoryName: "Cooldown Crime",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 342,
    categoryId: 24,
    typeId: 6,
    categoryName: "Cooldown Crime",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 343,
    categoryId: 24,
    typeId: 7,
    categoryName: "Cooldown Crime",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 344,
    categoryId: 24,
    typeId: 8,
    categoryName: "Cooldown Crime",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 345,
    categoryId: 24,
    typeId: 9,
    categoryName: "Cooldown Crime",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 346,
    categoryId: 24,
    typeId: 10,
    categoryName: "Cooldown Crime",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 347,
    categoryId: 24,
    typeId: 11,
    categoryName: "Cooldown Crime",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 348,
    categoryId: 24,
    typeId: 12,
    categoryName: "Cooldown Crime",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 349,
    categoryId: 24,
    typeId: 13,
    categoryName: "Cooldown Crime",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 350,
    categoryId: 24,
    typeId: 14,
    categoryName: "Cooldown Crime",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 351,
    categoryId: 24,
    typeId: 15,
    categoryName: "Cooldown Crime",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 352,
    categoryId: 24,
    typeId: 16,
    categoryName: "Cooldown Crime",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 353,
    categoryId: 24,
    typeId: 17,
    categoryName: "Cooldown Crime",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 354,
    categoryId: 25,
    typeId: 0,
    categoryName: "Cooldown Nick a car",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 355,
    categoryId: 25,
    typeId: 1,
    categoryName: "Cooldown Nick a car",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 356,
    categoryId: 25,
    typeId: 2,
    categoryName: "Cooldown Nick a car",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 357,
    categoryId: 25,
    typeId: 3,
    categoryName: "Cooldown Nick a car",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 358,
    categoryId: 25,
    typeId: 4,
    categoryName: "Cooldown Nick a car",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 359,
    categoryId: 25,
    typeId: 5,
    categoryName: "Cooldown Nick a car",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 360,
    categoryId: 25,
    typeId: 6,
    categoryName: "Cooldown Nick a car",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 361,
    categoryId: 25,
    typeId: 7,
    categoryName: "Cooldown Nick a car",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 362,
    categoryId: 25,
    typeId: 8,
    categoryName: "Cooldown Nick a car",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 363,
    categoryId: 25,
    typeId: 9,
    categoryName: "Cooldown Nick a car",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 364,
    categoryId: 25,
    typeId: 10,
    categoryName: "Cooldown Nick a car",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 365,
    categoryId: 25,
    typeId: 11,
    categoryName: "Cooldown Nick a car",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 366,
    categoryId: 25,
    typeId: 12,
    categoryName: "Cooldown Nick a car",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 367,
    categoryId: 25,
    typeId: 13,
    categoryName: "Cooldown Nick a car",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 368,
    categoryId: 25,
    typeId: 14,
    categoryName: "Cooldown Nick a car",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 369,
    categoryId: 25,
    typeId: 15,
    categoryName: "Cooldown Nick a car",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 370,
    categoryId: 25,
    typeId: 16,
    categoryName: "Cooldown Nick a car",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 371,
    categoryId: 25,
    typeId: 17,
    categoryName: "Cooldown Nick a car",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 372,
    categoryId: 26,
    typeId: 0,
    categoryName: "Cooldown Booze",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 373,
    categoryId: 26,
    typeId: 1,
    categoryName: "Cooldown Booze",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 374,
    categoryId: 26,
    typeId: 2,
    categoryName: "Cooldown Booze",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 375,
    categoryId: 26,
    typeId: 3,
    categoryName: "Cooldown Booze",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 376,
    categoryId: 26,
    typeId: 4,
    categoryName: "Cooldown Booze",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 377,
    categoryId: 26,
    typeId: 5,
    categoryName: "Cooldown Booze",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 378,
    categoryId: 26,
    typeId: 6,
    categoryName: "Cooldown Booze",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 379,
    categoryId: 26,
    typeId: 7,
    categoryName: "Cooldown Booze",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 380,
    categoryId: 26,
    typeId: 8,
    categoryName: "Cooldown Booze",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 381,
    categoryId: 26,
    typeId: 9,
    categoryName: "Cooldown Booze",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 382,
    categoryId: 26,
    typeId: 10,
    categoryName: "Cooldown Booze",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 383,
    categoryId: 26,
    typeId: 11,
    categoryName: "Cooldown Booze",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 384,
    categoryId: 26,
    typeId: 12,
    categoryName: "Cooldown Booze",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 385,
    categoryId: 26,
    typeId: 13,
    categoryName: "Cooldown Booze",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 386,
    categoryId: 26,
    typeId: 14,
    categoryName: "Cooldown Booze",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 387,
    categoryId: 26,
    typeId: 15,
    categoryName: "Cooldown Booze",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 388,
    categoryId: 26,
    typeId: 16,
    categoryName: "Cooldown Booze",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 389,
    categoryId: 26,
    typeId: 17,
    categoryName: "Cooldown Booze",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 390,
    categoryId: 27,
    typeId: 0,
    categoryName: "Cooldown Narcotics",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 391,
    categoryId: 27,
    typeId: 1,
    categoryName: "Cooldown Narcotics",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 392,
    categoryId: 27,
    typeId: 2,
    categoryName: "Cooldown Narcotics",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 393,
    categoryId: 27,
    typeId: 3,
    categoryName: "Cooldown Narcotics",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 394,
    categoryId: 27,
    typeId: 4,
    categoryName: "Cooldown Narcotics",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 395,
    categoryId: 27,
    typeId: 5,
    categoryName: "Cooldown Narcotics",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 396,
    categoryId: 27,
    typeId: 6,
    categoryName: "Cooldown Narcotics",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 397,
    categoryId: 27,
    typeId: 7,
    categoryName: "Cooldown Narcotics",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 398,
    categoryId: 27,
    typeId: 8,
    categoryName: "Cooldown Narcotics",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 399,
    categoryId: 27,
    typeId: 9,
    categoryName: "Cooldown Narcotics",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 400,
    categoryId: 27,
    typeId: 10,
    categoryName: "Cooldown Narcotics",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 401,
    categoryId: 27,
    typeId: 11,
    categoryName: "Cooldown Narcotics",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 402,
    categoryId: 27,
    typeId: 12,
    categoryName: "Cooldown Narcotics",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 403,
    categoryId: 27,
    typeId: 13,
    categoryName: "Cooldown Narcotics",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 404,
    categoryId: 27,
    typeId: 14,
    categoryName: "Cooldown Narcotics",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 405,
    categoryId: 27,
    typeId: 15,
    categoryName: "Cooldown Narcotics",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 406,
    categoryId: 27,
    typeId: 16,
    categoryName: "Cooldown Narcotics",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 407,
    categoryId: 27,
    typeId: 17,
    categoryName: "Cooldown Narcotics",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 408,
    categoryId: 28,
    typeId: 0,
    categoryName: "Cooldown Killskill",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 409,
    categoryId: 28,
    typeId: 1,
    categoryName: "Cooldown Killskill",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 410,
    categoryId: 28,
    typeId: 2,
    categoryName: "Cooldown Killskill",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 411,
    categoryId: 28,
    typeId: 3,
    categoryName: "Cooldown Killskill",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 412,
    categoryId: 28,
    typeId: 4,
    categoryName: "Cooldown Killskill",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 413,
    categoryId: 28,
    typeId: 5,
    categoryName: "Cooldown Killskill",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 414,
    categoryId: 28,
    typeId: 6,
    categoryName: "Cooldown Killskill",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 415,
    categoryId: 28,
    typeId: 7,
    categoryName: "Cooldown Killskill",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 416,
    categoryId: 28,
    typeId: 8,
    categoryName: "Cooldown Killskill",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 417,
    categoryId: 28,
    typeId: 9,
    categoryName: "Cooldown Killskill",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 418,
    categoryId: 28,
    typeId: 10,
    categoryName: "Cooldown Killskill",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 419,
    categoryId: 28,
    typeId: 11,
    categoryName: "Cooldown Killskill",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 420,
    categoryId: 28,
    typeId: 12,
    categoryName: "Cooldown Killskill",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 421,
    categoryId: 28,
    typeId: 13,
    categoryName: "Cooldown Killskill",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 422,
    categoryId: 28,
    typeId: 14,
    categoryName: "Cooldown Killskill",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 423,
    categoryId: 28,
    typeId: 15,
    categoryName: "Cooldown Killskill",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 424,
    categoryId: 28,
    typeId: 16,
    categoryName: "Cooldown Killskill",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 425,
    categoryId: 28,
    typeId: 17,
    categoryName: "Cooldown Killskill",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 426,
    categoryId: 29,
    typeId: 0,
    categoryName: "Cooldown Travel",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 427,
    categoryId: 29,
    typeId: 1,
    categoryName: "Cooldown Travel",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 428,
    categoryId: 29,
    typeId: 2,
    categoryName: "Cooldown Travel",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 429,
    categoryId: 29,
    typeId: 3,
    categoryName: "Cooldown Travel",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 430,
    categoryId: 29,
    typeId: 4,
    categoryName: "Cooldown Travel",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 431,
    categoryId: 29,
    typeId: 5,
    categoryName: "Cooldown Travel",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 432,
    categoryId: 29,
    typeId: 6,
    categoryName: "Cooldown Travel",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 433,
    categoryId: 29,
    typeId: 7,
    categoryName: "Cooldown Travel",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 434,
    categoryId: 29,
    typeId: 8,
    categoryName: "Cooldown Travel",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 435,
    categoryId: 29,
    typeId: 9,
    categoryName: "Cooldown Travel",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 436,
    categoryId: 29,
    typeId: 10,
    categoryName: "Cooldown Travel",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 437,
    categoryId: 29,
    typeId: 11,
    categoryName: "Cooldown Travel",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 438,
    categoryId: 29,
    typeId: 12,
    categoryName: "Cooldown Travel",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 439,
    categoryId: 29,
    typeId: 13,
    categoryName: "Cooldown Travel",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 440,
    categoryId: 29,
    typeId: 14,
    categoryName: "Cooldown Travel",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 441,
    categoryId: 29,
    typeId: 15,
    categoryName: "Cooldown Travel",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 442,
    categoryId: 29,
    typeId: 16,
    categoryName: "Cooldown Travel",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 443,
    categoryId: 29,
    typeId: 17,
    categoryName: "Cooldown Travel",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 444,
    categoryId: 30,
    typeId: 0,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 445,
    categoryId: 30,
    typeId: 1,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 446,
    categoryId: 30,
    typeId: 2,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 447,
    categoryId: 30,
    typeId: 3,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 448,
    categoryId: 30,
    typeId: 4,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 449,
    categoryId: 30,
    typeId: 5,
    categoryName: "Cooldown Bullet buy",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 450,
    categoryId: 30,
    typeId: 6,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 451,
    categoryId: 30,
    typeId: 7,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 452,
    categoryId: 30,
    typeId: 8,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 453,
    categoryId: 30,
    typeId: 9,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 454,
    categoryId: 30,
    typeId: 10,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 455,
    categoryId: 30,
    typeId: 11,
    categoryName: "Cooldown Bullet buy",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 456,
    categoryId: 30,
    typeId: 12,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 457,
    categoryId: 30,
    typeId: 13,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 458,
    categoryId: 30,
    typeId: 14,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 459,
    categoryId: 30,
    typeId: 15,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 460,
    categoryId: 30,
    typeId: 16,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 461,
    categoryId: 30,
    typeId: 17,
    categoryName: "Cooldown Bullet buy",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 462,
    categoryId: 31,
    typeId: 0,
    categoryName: "Cooldown Health buy",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 463,
    categoryId: 31,
    typeId: 1,
    categoryName: "Cooldown Health buy",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 464,
    categoryId: 31,
    typeId: 2,
    categoryName: "Cooldown Health buy",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 465,
    categoryId: 31,
    typeId: 3,
    categoryName: "Cooldown Health buy",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 466,
    categoryId: 31,
    typeId: 4,
    categoryName: "Cooldown Health buy",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 467,
    categoryId: 31,
    typeId: 5,
    categoryName: "Cooldown Health buy",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 468,
    categoryId: 31,
    typeId: 6,
    categoryName: "Cooldown Health buy",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 469,
    categoryId: 31,
    typeId: 7,
    categoryName: "Cooldown Health buy",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 470,
    categoryId: 31,
    typeId: 8,
    categoryName: "Cooldown Health buy",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 471,
    categoryId: 31,
    typeId: 9,
    categoryName: "Cooldown Health buy",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 472,
    categoryId: 31,
    typeId: 10,
    categoryName: "Cooldown Health buy",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 473,
    categoryId: 31,
    typeId: 11,
    categoryName: "Cooldown Health buy",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 474,
    categoryId: 31,
    typeId: 12,
    categoryName: "Cooldown Health buy",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 475,
    categoryId: 31,
    typeId: 13,
    categoryName: "Cooldown Health buy",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 476,
    categoryId: 31,
    typeId: 14,
    categoryName: "Cooldown Health buy",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 477,
    categoryId: 31,
    typeId: 15,
    categoryName: "Cooldown Health buy",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 478,
    categoryId: 31,
    typeId: 16,
    categoryName: "Cooldown Health buy",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 479,
    categoryId: 31,
    typeId: 17,
    categoryName: "Cooldown Health buy",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 480,
    categoryId: 32,
    typeId: 0,
    categoryName: "Cooldown Bust out",
    typeName: "90-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 481,
    categoryId: 32,
    typeId: 1,
    categoryName: "Cooldown Bust out",
    typeName: "90-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 482,
    categoryId: 32,
    typeId: 2,
    categoryName: "Cooldown Bust out",
    typeName: "90-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 483,
    categoryId: 32,
    typeId: 3,
    categoryName: "Cooldown Bust out",
    typeName: "90-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 484,
    categoryId: 32,
    typeId: 4,
    categoryName: "Cooldown Bust out",
    typeName: "90-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 485,
    categoryId: 32,
    typeId: 5,
    categoryName: "Cooldown Bust out",
    typeName: "90-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 486,
    categoryId: 32,
    typeId: 6,
    categoryName: "Cooldown Bust out",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 487,
    categoryId: 32,
    typeId: 7,
    categoryName: "Cooldown Bust out",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 488,
    categoryId: 32,
    typeId: 8,
    categoryName: "Cooldown Bust out",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 489,
    categoryId: 32,
    typeId: 9,
    categoryName: "Cooldown Bust out",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 490,
    categoryId: 32,
    typeId: 10,
    categoryName: "Cooldown Bust out",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 491,
    categoryId: 32,
    typeId: 11,
    categoryName: "Cooldown Bust out",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 492,
    categoryId: 32,
    typeId: 12,
    categoryName: "Cooldown Bust out",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 493,
    categoryId: 32,
    typeId: 13,
    categoryName: "Cooldown Bust out",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 494,
    categoryId: 32,
    typeId: 14,
    categoryName: "Cooldown Bust out",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 495,
    categoryId: 32,
    typeId: 15,
    categoryName: "Cooldown Bust out",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 496,
    categoryId: 32,
    typeId: 16,
    categoryName: "Cooldown Bust out",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 497,
    categoryId: 32,
    typeId: 17,
    categoryName: "Cooldown Bust out",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 498,
    categoryId: 33,
    typeId: 0,
    categoryName: "Booster Map yield",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 499,
    categoryId: 33,
    typeId: 1,
    categoryName: "Booster Map yield",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 500,
    categoryId: 33,
    typeId: 2,
    categoryName: "Booster Map yield",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 501,
    categoryId: 33,
    typeId: 3,
    categoryName: "Booster Map yield",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 502,
    categoryId: 33,
    typeId: 4,
    categoryName: "Booster Map yield",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 503,
    categoryId: 33,
    typeId: 5,
    categoryName: "Booster Map yield",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 504,
    categoryId: 33,
    typeId: 6,
    categoryName: "Booster Map yield",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 505,
    categoryId: 33,
    typeId: 7,
    categoryName: "Booster Map yield",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 506,
    categoryId: 33,
    typeId: 8,
    categoryName: "Booster Map yield",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 507,
    categoryId: 33,
    typeId: 9,
    categoryName: "Booster Map yield",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 508,
    categoryId: 33,
    typeId: 10,
    categoryName: "Booster Map yield",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 509,
    categoryId: 33,
    typeId: 11,
    categoryName: "Booster Map yield",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 510,
    categoryId: 33,
    typeId: 12,
    categoryName: "Booster Map yield",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 511,
    categoryId: 33,
    typeId: 13,
    categoryName: "Booster Map yield",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 512,
    categoryId: 33,
    typeId: 14,
    categoryName: "Booster Map yield",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 513,
    categoryId: 33,
    typeId: 15,
    categoryName: "Booster Map yield",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 514,
    categoryId: 33,
    typeId: 16,
    categoryName: "Booster Map yield",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 515,
    categoryId: 33,
    typeId: 17,
    categoryName: "Booster Map yield",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 516,
    categoryId: 33,
    typeId: 18,
    categoryName: "Booster Map yield",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 517,
    categoryId: 33,
    typeId: 19,
    categoryName: "Booster Map yield",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 518,
    categoryId: 33,
    typeId: 20,
    categoryName: "Booster Map yield",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 519,
    categoryId: 33,
    typeId: 21,
    categoryName: "Booster Map yield",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 520,
    categoryId: 33,
    typeId: 22,
    categoryName: "Booster Map yield",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 521,
    categoryId: 33,
    typeId: 23,
    categoryName: "Booster Map yield",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 522,
    categoryId: 34,
    typeId: 0,
    categoryName: "Booster Race XP",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 523,
    categoryId: 34,
    typeId: 1,
    categoryName: "Booster Race XP",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 524,
    categoryId: 34,
    typeId: 2,
    categoryName: "Booster Race XP",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 525,
    categoryId: 34,
    typeId: 3,
    categoryName: "Booster Race XP",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 526,
    categoryId: 34,
    typeId: 4,
    categoryName: "Booster Race XP",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 527,
    categoryId: 34,
    typeId: 5,
    categoryName: "Booster Race XP",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 528,
    categoryId: 34,
    typeId: 6,
    categoryName: "Booster Race XP",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 529,
    categoryId: 34,
    typeId: 7,
    categoryName: "Booster Race XP",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 530,
    categoryId: 34,
    typeId: 8,
    categoryName: "Booster Race XP",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 531,
    categoryId: 34,
    typeId: 9,
    categoryName: "Booster Race XP",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 532,
    categoryId: 34,
    typeId: 10,
    categoryName: "Booster Race XP",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 533,
    categoryId: 34,
    typeId: 11,
    categoryName: "Booster Race XP",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 534,
    categoryId: 34,
    typeId: 12,
    categoryName: "Booster Race XP",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 535,
    categoryId: 34,
    typeId: 13,
    categoryName: "Booster Race XP",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 536,
    categoryId: 34,
    typeId: 14,
    categoryName: "Booster Race XP",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 537,
    categoryId: 34,
    typeId: 15,
    categoryName: "Booster Race XP",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 538,
    categoryId: 34,
    typeId: 16,
    categoryName: "Booster Race XP",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 539,
    categoryId: 34,
    typeId: 17,
    categoryName: "Booster Race XP",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 540,
    categoryId: 34,
    typeId: 18,
    categoryName: "Booster Race XP",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 541,
    categoryId: 34,
    typeId: 19,
    categoryName: "Booster Race XP",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 542,
    categoryId: 34,
    typeId: 20,
    categoryName: "Booster Race XP",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 543,
    categoryId: 34,
    typeId: 21,
    categoryName: "Booster Race XP",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 544,
    categoryId: 34,
    typeId: 22,
    categoryName: "Booster Race XP",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 545,
    categoryId: 34,
    typeId: 23,
    categoryName: "Booster Race XP",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 546,
    categoryId: 35,
    typeId: 0,
    categoryName: "Booster Killskill XP",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 547,
    categoryId: 35,
    typeId: 1,
    categoryName: "Booster Killskill XP",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 548,
    categoryId: 35,
    typeId: 2,
    categoryName: "Booster Killskill XP",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 549,
    categoryId: 35,
    typeId: 3,
    categoryName: "Booster Killskill XP",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 550,
    categoryId: 35,
    typeId: 4,
    categoryName: "Booster Killskill XP",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 551,
    categoryId: 35,
    typeId: 5,
    categoryName: "Booster Killskill XP",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 552,
    categoryId: 35,
    typeId: 6,
    categoryName: "Booster Killskill XP",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 553,
    categoryId: 35,
    typeId: 7,
    categoryName: "Booster Killskill XP",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 554,
    categoryId: 35,
    typeId: 8,
    categoryName: "Booster Killskill XP",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 555,
    categoryId: 35,
    typeId: 9,
    categoryName: "Booster Killskill XP",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 556,
    categoryId: 35,
    typeId: 10,
    categoryName: "Booster Killskill XP",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 557,
    categoryId: 35,
    typeId: 11,
    categoryName: "Booster Killskill XP",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 558,
    categoryId: 35,
    typeId: 12,
    categoryName: "Booster Killskill XP",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 559,
    categoryId: 35,
    typeId: 13,
    categoryName: "Booster Killskill XP",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 560,
    categoryId: 35,
    typeId: 14,
    categoryName: "Booster Killskill XP",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 561,
    categoryId: 35,
    typeId: 15,
    categoryName: "Booster Killskill XP",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 562,
    categoryId: 35,
    typeId: 16,
    categoryName: "Booster Killskill XP",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 563,
    categoryId: 35,
    typeId: 17,
    categoryName: "Booster Killskill XP",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 564,
    categoryId: 35,
    typeId: 18,
    categoryName: "Booster Killskill XP",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 565,
    categoryId: 35,
    typeId: 19,
    categoryName: "Booster Killskill XP",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 566,
    categoryId: 35,
    typeId: 20,
    categoryName: "Booster Killskill XP",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 567,
    categoryId: 35,
    typeId: 21,
    categoryName: "Booster Killskill XP",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 568,
    categoryId: 35,
    typeId: 22,
    categoryName: "Booster Killskill XP",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 569,
    categoryId: 35,
    typeId: 23,
    categoryName: "Booster Killskill XP",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 570,
    categoryId: 36,
    typeId: 0,
    categoryName: "Booster Bust out XP",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 571,
    categoryId: 36,
    typeId: 1,
    categoryName: "Booster Bust out XP",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 572,
    categoryId: 36,
    typeId: 2,
    categoryName: "Booster Bust out XP",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 573,
    categoryId: 36,
    typeId: 3,
    categoryName: "Booster Bust out XP",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 574,
    categoryId: 36,
    typeId: 4,
    categoryName: "Booster Bust out XP",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 575,
    categoryId: 36,
    typeId: 5,
    categoryName: "Booster Bust out XP",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 576,
    categoryId: 36,
    typeId: 6,
    categoryName: "Booster Bust out XP",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 577,
    categoryId: 36,
    typeId: 7,
    categoryName: "Booster Bust out XP",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 578,
    categoryId: 36,
    typeId: 8,
    categoryName: "Booster Bust out XP",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 579,
    categoryId: 36,
    typeId: 9,
    categoryName: "Booster Bust out XP",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 580,
    categoryId: 36,
    typeId: 10,
    categoryName: "Booster Bust out XP",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 581,
    categoryId: 36,
    typeId: 11,
    categoryName: "Booster Bust out XP",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 582,
    categoryId: 36,
    typeId: 12,
    categoryName: "Booster Bust out XP",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 583,
    categoryId: 36,
    typeId: 13,
    categoryName: "Booster Bust out XP",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 584,
    categoryId: 36,
    typeId: 14,
    categoryName: "Booster Bust out XP",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 585,
    categoryId: 36,
    typeId: 15,
    categoryName: "Booster Bust out XP",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 586,
    categoryId: 36,
    typeId: 16,
    categoryName: "Booster Bust out XP",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 587,
    categoryId: 36,
    typeId: 17,
    categoryName: "Booster Bust out XP",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 588,
    categoryId: 36,
    typeId: 18,
    categoryName: "Booster Bust out XP",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 589,
    categoryId: 36,
    typeId: 19,
    categoryName: "Booster Bust out XP",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 590,
    categoryId: 36,
    typeId: 20,
    categoryName: "Booster Bust out XP",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 591,
    categoryId: 36,
    typeId: 21,
    categoryName: "Booster Bust out XP",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 592,
    categoryId: 36,
    typeId: 22,
    categoryName: "Booster Bust out XP",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 593,
    categoryId: 36,
    typeId: 23,
    categoryName: "Booster Bust out XP",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 594,
    categoryId: 37,
    typeId: 0,
    categoryName: "Booster Narcs sales price",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 595,
    categoryId: 37,
    typeId: 1,
    categoryName: "Booster Narcs sales price",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 596,
    categoryId: 37,
    typeId: 2,
    categoryName: "Booster Narcs sales price",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 597,
    categoryId: 37,
    typeId: 3,
    categoryName: "Booster Narcs sales price",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 598,
    categoryId: 37,
    typeId: 4,
    categoryName: "Booster Narcs sales price",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 599,
    categoryId: 37,
    typeId: 5,
    categoryName: "Booster Narcs sales price",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 600,
    categoryId: 37,
    typeId: 6,
    categoryName: "Booster Narcs sales price",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 601,
    categoryId: 37,
    typeId: 7,
    categoryName: "Booster Narcs sales price",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 602,
    categoryId: 37,
    typeId: 8,
    categoryName: "Booster Narcs sales price",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 603,
    categoryId: 37,
    typeId: 9,
    categoryName: "Booster Narcs sales price",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 604,
    categoryId: 37,
    typeId: 10,
    categoryName: "Booster Narcs sales price",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 605,
    categoryId: 37,
    typeId: 11,
    categoryName: "Booster Narcs sales price",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 606,
    categoryId: 37,
    typeId: 12,
    categoryName: "Booster Narcs sales price",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 607,
    categoryId: 37,
    typeId: 13,
    categoryName: "Booster Narcs sales price",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 608,
    categoryId: 37,
    typeId: 14,
    categoryName: "Booster Narcs sales price",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 609,
    categoryId: 37,
    typeId: 15,
    categoryName: "Booster Narcs sales price",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 610,
    categoryId: 37,
    typeId: 16,
    categoryName: "Booster Narcs sales price",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 611,
    categoryId: 37,
    typeId: 17,
    categoryName: "Booster Narcs sales price",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 612,
    categoryId: 37,
    typeId: 18,
    categoryName: "Booster Narcs sales price",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 613,
    categoryId: 37,
    typeId: 19,
    categoryName: "Booster Narcs sales price",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 614,
    categoryId: 37,
    typeId: 20,
    categoryName: "Booster Narcs sales price",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 615,
    categoryId: 37,
    typeId: 21,
    categoryName: "Booster Narcs sales price",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 616,
    categoryId: 37,
    typeId: 22,
    categoryName: "Booster Narcs sales price",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 617,
    categoryId: 37,
    typeId: 23,
    categoryName: "Booster Narcs sales price",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 618,
    categoryId: 38,
    typeId: 0,
    categoryName: "Booster Booze sales price",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 619,
    categoryId: 38,
    typeId: 1,
    categoryName: "Booster Booze sales price",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 620,
    categoryId: 38,
    typeId: 2,
    categoryName: "Booster Booze sales price",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 621,
    categoryId: 38,
    typeId: 3,
    categoryName: "Booster Booze sales price",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 622,
    categoryId: 38,
    typeId: 4,
    categoryName: "Booster Booze sales price",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 623,
    categoryId: 38,
    typeId: 5,
    categoryName: "Booster Booze sales price",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 624,
    categoryId: 38,
    typeId: 6,
    categoryName: "Booster Booze sales price",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 625,
    categoryId: 38,
    typeId: 7,
    categoryName: "Booster Booze sales price",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 626,
    categoryId: 38,
    typeId: 8,
    categoryName: "Booster Booze sales price",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 627,
    categoryId: 38,
    typeId: 9,
    categoryName: "Booster Booze sales price",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 628,
    categoryId: 38,
    typeId: 10,
    categoryName: "Booster Booze sales price",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 629,
    categoryId: 38,
    typeId: 11,
    categoryName: "Booster Booze sales price",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 630,
    categoryId: 38,
    typeId: 12,
    categoryName: "Booster Booze sales price",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 631,
    categoryId: 38,
    typeId: 13,
    categoryName: "Booster Booze sales price",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 632,
    categoryId: 38,
    typeId: 14,
    categoryName: "Booster Booze sales price",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 633,
    categoryId: 38,
    typeId: 15,
    categoryName: "Booster Booze sales price",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 634,
    categoryId: 38,
    typeId: 16,
    categoryName: "Booster Booze sales price",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 635,
    categoryId: 38,
    typeId: 17,
    categoryName: "Booster Booze sales price",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 636,
    categoryId: 38,
    typeId: 18,
    categoryName: "Booster Booze sales price",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 637,
    categoryId: 38,
    typeId: 19,
    categoryName: "Booster Booze sales price",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 638,
    categoryId: 38,
    typeId: 20,
    categoryName: "Booster Booze sales price",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 639,
    categoryId: 38,
    typeId: 21,
    categoryName: "Booster Booze sales price",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 640,
    categoryId: 38,
    typeId: 22,
    categoryName: "Booster Booze sales price",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 641,
    categoryId: 38,
    typeId: 23,
    categoryName: "Booster Booze sales price",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 642,
    categoryId: 39,
    typeId: 0,
    categoryName: " Booster Worth",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 643,
    categoryId: 39,
    typeId: 1,
    categoryName: " Booster Worth",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 644,
    categoryId: 39,
    typeId: 2,
    categoryName: " Booster Worth",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 645,
    categoryId: 39,
    typeId: 3,
    categoryName: " Booster Worth",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 646,
    categoryId: 39,
    typeId: 4,
    categoryName: " Booster Worth",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 647,
    categoryId: 39,
    typeId: 5,
    categoryName: " Booster Worth",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 648,
    categoryId: 39,
    typeId: 6,
    categoryName: " Booster Worth",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 649,
    categoryId: 39,
    typeId: 7,
    categoryName: " Booster Worth",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 650,
    categoryId: 39,
    typeId: 8,
    categoryName: " Booster Worth",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 651,
    categoryId: 39,
    typeId: 9,
    categoryName: " Booster Worth",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 652,
    categoryId: 39,
    typeId: 10,
    categoryName: " Booster Worth",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 653,
    categoryId: 39,
    typeId: 11,
    categoryName: " Booster Worth",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 654,
    categoryId: 39,
    typeId: 12,
    categoryName: " Booster Worth",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 655,
    categoryId: 39,
    typeId: 13,
    categoryName: " Booster Worth",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 656,
    categoryId: 39,
    typeId: 14,
    categoryName: " Booster Worth",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 657,
    categoryId: 39,
    typeId: 15,
    categoryName: " Booster Worth",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 658,
    categoryId: 39,
    typeId: 16,
    categoryName: " Booster Worth",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 659,
    categoryId: 39,
    typeId: 17,
    categoryName: " Booster Worth",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 660,
    categoryId: 39,
    typeId: 18,
    categoryName: " Booster Worth",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 661,
    categoryId: 39,
    typeId: 19,
    categoryName: " Booster Worth",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 662,
    categoryId: 39,
    typeId: 20,
    categoryName: " Booster Worth",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 663,
    categoryId: 39,
    typeId: 21,
    categoryName: " Booster Worth",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 664,
    categoryId: 39,
    typeId: 22,
    categoryName: " Booster Worth",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 665,
    categoryId: 39,
    typeId: 23,
    categoryName: " Booster Worth",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 666,
    categoryId: 40,
    typeId: 0,
    categoryName: "Booster Crime rewards",
    typeName: "100-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 667,
    categoryId: 40,
    typeId: 1,
    categoryName: "Booster Crime rewards",
    typeName: "100-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 668,
    categoryId: 40,
    typeId: 2,
    categoryName: "Booster Crime rewards",
    typeName: "100-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 669,
    categoryId: 40,
    typeId: 3,
    categoryName: "Booster Crime rewards",
    typeName: "100-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 670,
    categoryId: 40,
    typeId: 4,
    categoryName: "Booster Crime rewards",
    typeName: "100-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 671,
    categoryId: 40,
    typeId: 5,
    categoryName: "Booster Crime rewards",
    typeName: "100-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 672,
    categoryId: 40,
    typeId: 6,
    categoryName: "Booster Crime rewards",
    typeName: "75-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 673,
    categoryId: 40,
    typeId: 7,
    categoryName: "Booster Crime rewards",
    typeName: "75-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 674,
    categoryId: 40,
    typeId: 8,
    categoryName: "Booster Crime rewards",
    typeName: "75-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 675,
    categoryId: 40,
    typeId: 9,
    categoryName: "Booster Crime rewards",
    typeName: "75-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 676,
    categoryId: 40,
    typeId: 10,
    categoryName: "Booster Crime rewards",
    typeName: "75-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 677,
    categoryId: 40,
    typeId: 11,
    categoryName: "Booster Crime rewards",
    typeName: "75-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 678,
    categoryId: 40,
    typeId: 12,
    categoryName: "Booster Crime rewards",
    typeName: "50-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 679,
    categoryId: 40,
    typeId: 13,
    categoryName: "Booster Crime rewards",
    typeName: "50-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 680,
    categoryId: 40,
    typeId: 14,
    categoryName: "Booster Crime rewards",
    typeName: "50-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 681,
    categoryId: 40,
    typeId: 15,
    categoryName: "Booster Crime rewards",
    typeName: "50-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 682,
    categoryId: 40,
    typeId: 16,
    categoryName: "Booster Crime rewards",
    typeName: "50-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 683,
    categoryId: 40,
    typeId: 17,
    categoryName: "Booster Crime rewards",
    typeName: "50-96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 684,
    categoryId: 40,
    typeId: 18,
    categoryName: "Booster Crime rewards",
    typeName: "25-6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 685,
    categoryId: 40,
    typeId: 19,
    categoryName: "Booster Crime rewards",
    typeName: "25-12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 686,
    categoryId: 40,
    typeId: 20,
    categoryName: "Booster Crime rewards",
    typeName: "25-24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 687,
    categoryId: 40,
    typeId: 21,
    categoryName: "Booster Crime rewards",
    typeName: "25-48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 688,
    categoryId: 40,
    typeId: 22,
    categoryName: "Booster Crime rewards",
    typeName: "25-72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 689,
    categoryId: 40,
    typeId: 23,
    categoryName: "Booster Crime rewards",
    typeName: "25-96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 690,
    categoryId: 41,
    typeId: 0,
    categoryName: "Double Purchase",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 691,
    categoryId: 41,
    typeId: 1,
    categoryName: "Double Purchase",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 692,
    categoryId: 41,
    typeId: 2,
    categoryName: "Double Purchase",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 693,
    categoryId: 41,
    typeId: 3,
    categoryName: "Double Purchase",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 694,
    categoryId: 41,
    typeId: 4,
    categoryName: "Double Purchase",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 695,
    categoryId: 41,
    typeId: 5,
    categoryName: "Double Purchase",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 696,
    categoryId: 42,
    typeId: 0,
    categoryName: "No jail time",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 697,
    categoryId: 42,
    typeId: 1,
    categoryName: "No jail time",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 698,
    categoryId: 42,
    typeId: 2,
    categoryName: "No jail time",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 699,
    categoryId: 42,
    typeId: 3,
    categoryName: "No jail time",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 700,
    categoryId: 42,
    typeId: 4,
    categoryName: "No jail time",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 701,
    categoryId: 42,
    typeId: 5,
    categoryName: "No jail time",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 702,
    categoryId: 43,
    typeId: 0,
    categoryName: "Free travel",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 703,
    categoryId: 43,
    typeId: 1,
    categoryName: "Free travel",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 704,
    categoryId: 43,
    typeId: 2,
    categoryName: "Free travel",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 705,
    categoryId: 43,
    typeId: 3,
    categoryName: "Free travel",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 706,
    categoryId: 43,
    typeId: 4,
    categoryName: "Free travel",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 707,
    categoryId: 43,
    typeId: 5,
    categoryName: "Free travel",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 708,
    categoryId: 44,
    typeId: 0,
    categoryName: "Bank fee0",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 709,
    categoryId: 44,
    typeId: 1,
    categoryName: "Bank fee0",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 710,
    categoryId: 44,
    typeId: 2,
    categoryName: "Bank fee0",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 711,
    categoryId: 44,
    typeId: 3,
    categoryName: "Bank fee0",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 712,
    categoryId: 44,
    typeId: 4,
    categoryName: "Bank fee0",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 713,
    categoryId: 44,
    typeId: 5,
    categoryName: "Bank fee0",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 714,
    categoryId: 45,
    typeId: 0,
    categoryName: "Credit cost 25",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 715,
    categoryId: 45,
    typeId: 1,
    categoryName: "Credit cost 25",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 716,
    categoryId: 45,
    typeId: 2,
    categoryName: "Credit cost 25",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 717,
    categoryId: 45,
    typeId: 3,
    categoryName: "Credit cost 25",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 718,
    categoryId: 45,
    typeId: 4,
    categoryName: "Credit cost 25",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 719,
    categoryId: 45,
    typeId: 5,
    categoryName: "Credit cost 25",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 720,
    categoryId: 46,
    typeId: 0,
    categoryName: "Increased conversion rate",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 721,
    categoryId: 46,
    typeId: 1,
    categoryName: "Increased conversion rate",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 722,
    categoryId: 46,
    typeId: 2,
    categoryName: "Increased conversion rate",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 723,
    categoryId: 46,
    typeId: 3,
    categoryName: "Increased conversion rate",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 724,
    categoryId: 46,
    typeId: 4,
    categoryName: "Increased conversion rate",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 725,
    categoryId: 46,
    typeId: 5,
    categoryName: "Increased conversion rate",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 726,
    categoryId: 47,
    typeId: 0,
    categoryName: "Credit spend -25%",
    typeName: "6",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 727,
    categoryId: 47,
    typeId: 1,
    categoryName: "Credit spend -25%",
    typeName: "12",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 728,
    categoryId: 47,
    typeId: 2,
    categoryName: "Credit spend -25%",
    typeName: "24",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 729,
    categoryId: 47,
    typeId: 3,
    categoryName: "Credit spend -25%",
    typeName: "48",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 730,
    categoryId: 47,
    typeId: 4,
    categoryName: "Credit spend -25%",
    typeName: "72",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 731,
    categoryId: 47,
    typeId: 5,
    categoryName: "Credit spend -25%",
    typeName: "96",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 732,
    categoryId: 48,
    typeId: 0,
    categoryName: "Bodyguard",
    typeName: "Lvl 1 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 733,
    categoryId: 48,
    typeId: 1,
    categoryName: "Bodyguard",
    typeName: "Lvl 2 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 734,
    categoryId: 48,
    typeId: 2,
    categoryName: "Bodyguard",
    typeName: "Lvl 3 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 735,
    categoryId: 48,
    typeId: 3,
    categoryName: "Bodyguard",
    typeName: "Lvl 4 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 736,
    categoryId: 48,
    typeId: 4,
    categoryName: "Bodyguard",
    typeName: "Lvl 5 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 737,
    categoryId: 48,
    typeId: 5,
    categoryName: "Bodyguard",
    typeName: "Lvl 6 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 738,
    categoryId: 48,
    typeId: 6,
    categoryName: "Bodyguard",
    typeName: "Lvl 7 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 739,
    categoryId: 48,
    typeId: 7,
    categoryName: "Bodyguard",
    typeName: "Lvl 8 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 740,
    categoryId: 48,
    typeId: 8,
    categoryName: "Bodyguard",
    typeName: "Lvl 9 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 741,
    categoryId: 48,
    typeId: 9,
    categoryName: "Bodyguard",
    typeName: "Lvl 10 - Johnny",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 742,
    categoryId: 49,
    typeId: 0,
    categoryName: "Bodyguard",
    typeName: "Lvl 1 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 743,
    categoryId: 49,
    typeId: 1,
    categoryName: "Bodyguard",
    typeName: "Lvl 2 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 744,
    categoryId: 49,
    typeId: 2,
    categoryName: "Bodyguard",
    typeName: "Lvl 3 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 745,
    categoryId: 49,
    typeId: 3,
    categoryName: "Bodyguard",
    typeName: "Lvl 4 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 746,
    categoryId: 49,
    typeId: 4,
    categoryName: "Bodyguard",
    typeName: "Lvl 5 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 747,
    categoryId: 49,
    typeId: 5,
    categoryName: "Bodyguard",
    typeName: "Lvl 6 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 748,
    categoryId: 49,
    typeId: 6,
    categoryName: "Bodyguard",
    typeName: "Lvl 7 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 749,
    categoryId: 49,
    typeId: 7,
    categoryName: "Bodyguard",
    typeName: "Lvl 8 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 750,
    categoryId: 49,
    typeId: 8,
    categoryName: "Bodyguard",
    typeName: "Lvl 9 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 751,
    categoryId: 49,
    typeId: 9,
    categoryName: "Bodyguard",
    typeName: "Lvl 10 - Jim",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 752,
    categoryId: 50,
    typeId: 0,
    categoryName: "Bodyguard",
    typeName: "Lvl 1 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 753,
    categoryId: 50,
    typeId: 1,
    categoryName: "Bodyguard",
    typeName: "Lvl 2 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 754,
    categoryId: 50,
    typeId: 2,
    categoryName: "Bodyguard",
    typeName: "Lvl 3 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 755,
    categoryId: 50,
    typeId: 3,
    categoryName: "Bodyguard",
    typeName: "Lvl 4 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 756,
    categoryId: 50,
    typeId: 4,
    categoryName: "Bodyguard",
    typeName: "Lvl 5 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 757,
    categoryId: 50,
    typeId: 5,
    categoryName: "Bodyguard",
    typeName: "Lvl 6 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 758,
    categoryId: 50,
    typeId: 6,
    categoryName: "Bodyguard",
    typeName: "Lvl 7 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 759,
    categoryId: 50,
    typeId: 7,
    categoryName: "Bodyguard",
    typeName: "Lvl 8 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 760,
    categoryId: 50,
    typeId: 8,
    categoryName: "Bodyguard",
    typeName: "Lvl 9 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 761,
    categoryId: 50,
    typeId: 9,
    categoryName: "Bodyguard",
    typeName: "Lvl 10 - Sam",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 762,
    categoryId: 51,
    typeId: 0,
    categoryName: "Bodyguard",
    typeName: "Lvl 1 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 763,
    categoryId: 51,
    typeId: 1,
    categoryName: "Bodyguard",
    typeName: "Lvl 2 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 764,
    categoryId: 51,
    typeId: 2,
    categoryName: "Bodyguard",
    typeName: "Lvl 3 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 765,
    categoryId: 51,
    typeId: 3,
    categoryName: "Bodyguard",
    typeName: "Lvl 4 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 766,
    categoryId: 51,
    typeId: 4,
    categoryName: "Bodyguard",
    typeName: "Lvl 5 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 767,
    categoryId: 51,
    typeId: 5,
    categoryName: "Bodyguard",
    typeName: "Lvl 6 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 768,
    categoryId: 51,
    typeId: 6,
    categoryName: "Bodyguard",
    typeName: "Lvl 7 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 769,
    categoryId: 51,
    typeId: 7,
    categoryName: "Bodyguard",
    typeName: "Lvl 8 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 770,
    categoryId: 51,
    typeId: 8,
    categoryName: "Bodyguard",
    typeName: "Lvl 9 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 771,
    categoryId: 51,
    typeId: 9,
    categoryName: "Bodyguard",
    typeName: "Lvl 10 - Frank",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 772,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 0,
    categoryName: "Subscription",
    typeName: "1 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 773,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 1,
    categoryName: "Subscription",
    typeName: "1 month Unlimited",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 774,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 2,
    categoryName: "Subscription",
    typeName: "1 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 775,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 3,
    categoryName: "Subscription",
    typeName: "1 month Unlimited",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 776,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 4,
    categoryName: "Subscription",
    typeName: "2 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 777,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 5,
    categoryName: "Subscription",
    typeName: "2 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 778,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 6,
    categoryName: "Subscription",
    typeName: "3 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 779,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 7,
    categoryName: "Subscription",
    typeName: "3 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 780,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 8,
    categoryName: "Subscription",
    typeName: "6 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 781,
    categoryId: ItemCategory.SUBSCRIPTION_ITEM,
    typeId: 9,
    categoryName: "Subscription",
    typeName: "6 month Player+",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 782,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 0,
    categoryName: "Subscription",
    typeName: "3",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 783,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 1,
    categoryName: "Subscription",
    typeName: "4",
    chance1: 0,
    chance2: 0,
  },

  {
    itemId: 784,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 2,
    categoryName: "Subscription",
    typeName: "5",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 785,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 3,
    categoryName: "Subscription",
    typeName: "7",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 786,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 4,
    categoryName: "Subscription",
    typeName: "10",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 787,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 5,
    categoryName: "Subscription",
    typeName: "15",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 788,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 6,
    categoryName: "Subscription",
    typeName: "25",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 789,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 7,
    categoryName: "Subscription",
    typeName: "50",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 790,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 8,
    categoryName: "Subscription",
    typeName: "75",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 791,
    categoryId: ItemCategory.GI_CREDIT,
    typeId: 9,
    categoryName: "Subscription",
    typeName: "100",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 792,
    categoryId: ItemCategory.MYSTERY_BOX,
    typeId: 0,
    categoryName: "Mystery Box",
    typeName: "Mystery Box",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 793,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 0,
    categoryName: "Booze Pack",
    typeName: "75 Beer",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 794,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 1,
    categoryName: "Booze Pack",
    typeName: "75 Wine",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 795,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 2,
    categoryName: "Booze Pack",
    typeName: "75 Port",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 796,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 3,
    categoryName: "Booze Pack",
    typeName: "75 Vodka",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 797,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 4,
    categoryName: "Booze Pack",
    typeName: "75 Whiskey",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 798,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 5,
    categoryName: "Booze Pack",
    typeName: "75 Cognac",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 799,
    categoryId: ItemCategory.BOOZE_PACK,
    typeId: 6,
    categoryName: "Booze Pack",
    typeName: "75 Tequila",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 800,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 0,
    categoryName: "Narcotics Pack",
    typeName: "50 Glue",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 801,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 1,
    categoryName: "Narcotics Pack",
    typeName: "50 Marijuana",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 802,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 2,
    categoryName: "Narcotics Pack",
    typeName: "50 Amphetamine",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 803,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 3,
    categoryName: "Narcotics Pack",
    typeName: "50 Cocaine",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 804,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 4,
    categoryName: "Narcotics Pack",
    typeName: "50 Morphine",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 805,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 5,
    categoryName: "Narcotics Pack",
    typeName: "50 Opium",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 806,
    categoryId: ItemCategory.NARCS_PACK,
    typeId: 6,
    categoryName: "Narcotics Pack",
    typeName: "50 Heroin",
    chance1: 0,
    chance2: 0,
  },
  {
    itemId: 807,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 0,
    categoryName: "FTS",
    typeName: "3 FTS",
  },
  {
    itemId: 808,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 1,
    categoryName: "FTS",
    typeName: "5 FTS",
  },
  {
    itemId: 809,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 2,
    categoryName: "FTS",
    typeName: "8 FTS",
  },
  {
    itemId: 810,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 3,
    categoryName: "FTS",
    typeName: "15 FTS",
  },
  {
    itemId: 811,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 4,
    categoryName: "FTS",
    typeName: "20 FTS",
  },
  {
    itemId: 812,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 5,
    categoryName: "FTS",
    typeName: "30 FTS",
  },
  {
    itemId: 813,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 6,
    categoryName: "FTS",
    typeName: "50 FTS",
  },
  {
    itemId: 814,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 7,
    categoryName: "FTS",
    typeName: "100 FTS",
  },
  {
    itemId: 815,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 8,
    categoryName: "FTS",
    typeName: "150 FTS",
  },
  {
    itemId: 816,
    categoryId: ItemCategory.FOUNDER_TABLE_SHARE,
    typeId: 9,
    categoryName: "FTS",
    typeName: "250 FTS",
  }
];
